import PropTypes from 'prop-types';

export default {
  classes: PropTypes.object,
  selectedPassenger: PropTypes.oneOfType([ PropTypes.string, PropTypes.number ]),
  handleClose: PropTypes.func,
};



// WEBPACK FOOTER //
// ./src/containers/passengers/common/editPassenger/EditPassengerProps.js